<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">IP 대역 설정</div>
        <div class="setting-addel mr-l15">
          <el-button @click="onAddIpBandwidth"><i class="fas fa-plus"></i></el-button>
          <el-button @click="onDelIpBandwidth" :disabled="selectedRowArray.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="ipTable" row-class-name="c-dblclick"
      @row-dblclick="onDblClickRow" @selection-change="changeHandleSelection" :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool" style="width:100%;"
      :show-custom-header="true">
    </el-table-wrapper>
    <w-ip-bandwidth-sliding-popup ref="bandwidthSlidingPopup" @load-data="loadData"></w-ip-bandwidth-sliding-popup>
  </div>
</w-settings-content-template>
</template>

<script>
import { isNil } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import NetdeviceIpManagement from '@/api/settings/netdevice/netdevice-ip-management';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WIpBandwidthSlidingPopup from './popup/IpBandwidthSlidingPopup';

export default {
  name: 'WIpBandwidthSetting',
  components: {
    WSettingsContentTemplate,
    WIpBandwidthSlidingPopup,
  },
  data() {
    return {
      columnDefault,
      total: null,
      selectedRowArray: [],
      showSearchTool: false,
      tableData: [],
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'scanStart',
          label: 'IP 주소',
          width: 150,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'subnet',
          label: '서브넷 마스크',
          width: 150,
          searchable: true,
        },
        {
          prop: 'dhcpRange',
          label: '관리구간',
        },
        {
          prop: 'purpose',
          label: '용도',
          formatter: this.getEmptyText,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'addressTypeName',
          label: '구분',
          searchable: true,
          sortable: true,
          width: 70,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.ipTable.getParameter();
      const params = {
        ...tableParams,
      };
      this.selectedRowArray = [];
      NetdeviceIpManagement.getNetIpBandList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    onAddIpBandwidth() {
      this.$refs.bandwidthSlidingPopup.open();
    },
    onDelIpBandwidth() {
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const target = 'IP대역';
        NetdeviceIpManagement.deleteNcmIpBandList(this.selectedRowArray).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    onDblClickRow(row) {
      this.$refs.bandwidthSlidingPopup.open(row);
    },
    getEmptyText(row, column, value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/IpManagementSettings/IpBandwidthSetting/index.vue